module.exports = __webpack_public_path__ + "img/05_Module-3@2x.9809bd6b.jpg";